import React, { useState } from "react";
import { ChevronRight, ChevronLeft, ChevronDown, ChevronUp } from "lucide-react";
import styles from "../../style/display/sidebar.module.css";

const Sidebar = ({ structure, onSelectPDF }) => {
  const [expandedFolders, setExpandedFolders] = useState({});
  const [isOpen, setIsOpen] = useState(false); // Mobile sidebar toggle

  const toggleFolder = (folderName) => {
    setExpandedFolders((prev) => ({
      ...prev,
      [folderName]: !prev[folderName],
    }));
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const renderItems = (items, level = 0) => {
    return items.map((item, index) => {
      const isFolder = item.children;
      const isExpanded = expandedFolders[item.name];

      return (
        <div key={index} className={`${styles.sidebarItem} mb-4 ml-${level * 4}`}>
          {isFolder ? (
            <div
              className={styles.folderToggle}
              onClick={() => toggleFolder(item.name)}
            >
              <span className="mr-2">
                {isExpanded ? <ChevronDown size={20} /> : <ChevronRight size={20} />}
              </span>
              <span className={styles.folderName}>{item.name}</span>
            </div>
          ) : (
            <button
              className={styles.pdfButton}
              onClick={() => onSelectPDF(item.url)}
            >
              {item.name}
            </button>
          )}
          {isFolder && isExpanded && item.children && (
            <div className={styles.childContainer}>
              {renderItems(item.children, level + 1)}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div>
      {/* Mobile Toggle Button - Always visible on mobile, hidden on desktop */}
      <button className={styles.sidebarToggleButton} onClick={toggleSidebar}>
        {isOpen ? <ChevronLeft size={24} /> : <ChevronRight size={24} />}
      </button>

      <div className={`${styles.sidebar} ${isOpen ? styles.open : ""}`}>
        <h2 className={styles.sidebarHeader}>PDF Library</h2>
        {renderItems(structure)}
      </div>
    </div>
  );
};

export default Sidebar;
